
export class WorkstationDowntimeModel {
    workstationId: string;
    workstationDesc: string;
    downTime: number;
    garmentSmv: number; // the smv
    downTimeReasonDesc: string;

    constructor(workstationId: string,
        workstationDesc: string,
        downTime: number,
        garmentSmv: number,
        downTimeReasonDesc: string ) {
            this.workstationId = workstationId;
            this.workstationDesc = workstationDesc;
            this.downTime = downTime;
            this.garmentSmv = garmentSmv;
            this.downTimeReasonDesc = downTimeReasonDesc;
    }
}